import React from 'react';
import ReactDOM from 'react-dom';
import ErrorBoundary from '../../ErrorBoundary';
import ApplicationSorter from './ApplicationSorter';
import ReadMoreFade from '../ReadMoreFade';

class ApplicationSorterWrapper extends React.Component {
    constructor(props) {
        super(props);

        let user = {
            uid: props.userUid,
            application_uid: props.applicationUid,
            status: parseInt(props.status)
        };

        this.state = {user};
    }

    render() {
        return this.state.user ? <div>
            <p>Cover letter:</p>
            <ReadMoreFade cacheKey={this.props.roleUid}>
                <div dangerouslySetInnerHTML={{__html:this.props.children}}></div>
            </ReadMoreFade>
            <ApplicationSorter
                user={this.state.user}
                wrapped={true}
            />
            </div> : null;
    }
}

let ApplicationSorterWrapperElements = document.getElementsByClassName('ApplicationSorterWrapper');
if (ApplicationSorterWrapperElements.length > 0) {
    for (let key in ApplicationSorterWrapperElements) {
        if (ApplicationSorterWrapperElements.hasOwnProperty(key) && typeof ApplicationSorterWrapperElements[key].getAttribute === 'function') {
            let applicationUid = ApplicationSorterWrapperElements[key].getAttribute('data-applicationUid');
            let status = ApplicationSorterWrapperElements[key].getAttribute('data-status');
            let userUid = ApplicationSorterWrapperElements[key].getAttribute('data-userUid');
            let jobTitle = ApplicationSorterWrapperElements[key].getAttribute('data-jobTitle');
            let roleTitle = ApplicationSorterWrapperElements[key].getAttribute('data-roleTitle');
            let roleUid = ApplicationSorterWrapperElements[key].getAttribute('data-roleUid');

            let children = ApplicationSorterWrapperElements[key].innerHTML;

            ReactDOM.render(
                <ErrorBoundary>
                    <ApplicationSorterWrapper
                        applicationUid={applicationUid}
                        status={status}
                        userUid={userUid}
                        jobTitle={jobTitle}
                        roleTitle={roleTitle}
                        roleUid={roleUid}
                        children={children}
                    />
                </ErrorBoundary>, ApplicationSorterWrapperElements[key]);
        }
    }
}